"use client"

import { useEffect, useRef } from 'react'
import {
  advanceKonamiBuffer,
  isKonamiComplete,
  type KonamiKey,
} from '@/lib/lawn-space-shooter/konami'

export function useKonamiCode(onActivate: () => void, enabled = true) {
  const bufferRef = useRef<KonamiKey[]>([])
  const callbackRef = useRef(onActivate)
  callbackRef.current = onActivate

  useEffect(() => {
    if (!enabled) return
    if (typeof window === 'undefined') return

    function handleKeydown(event: KeyboardEvent) {
      const target = event.target as HTMLElement | null
      if (target) {
        const tag = target.tagName
        if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT') return
        if (target.isContentEditable) return
      }
      const next = advanceKonamiBuffer(bufferRef.current, event.key)
      bufferRef.current = next
      if (isKonamiComplete(next)) {
        bufferRef.current = []
        callbackRef.current()
      }
    }

    window.addEventListener('keydown', handleKeydown)
    return () => window.removeEventListener('keydown', handleKeydown)
  }, [enabled])
}
